var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuroPersonaM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 107,
    viewBox: "0 0 132 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empresa",
    clipPath: "url(#clip0_320_263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.7042 105.424C47.1374 95.1868 45.9095 88.7839 27.6704 88.7839C9.43123 88.7839 8.18415 95.1868 1.65625 105.424",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.6703 79.4229C37.7435 79.4229 45.9095 71.2673 45.9095 61.2068C45.9095 51.1463 37.7435 42.9907 27.6703 42.9907C17.5971 42.9907 9.43115 51.1463 9.43115 61.2068C9.43115 71.2673 17.5971 79.4229 27.6703 79.4229Z",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M63.8761 86.9935C63.3729 86.9394 62.9103 86.6917 62.5867 86.303C62.263 85.9144 62.1035 85.4152 62.1418 84.9111V39.7991C62.1035 39.295 62.263 38.7957 62.5867 38.407C62.9103 38.0184 63.3729 37.7708 63.8761 37.7167H94.1772C94.6804 37.7708 95.143 38.0184 95.4666 38.407C95.7903 38.7957 95.9498 39.295 95.9115 39.7991V86.9935H63.8761Z",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M73.5215 51.982H83.8687",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M73.5215 60.6813H83.8687",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M73.5215 69.3807H83.8687",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M113.293 52.4296H120.639",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M113.293 61.888H120.639",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M113.293 71.3268H120.639",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M113.293 24.074H120.639",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M113.293 14.6157H120.639",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M113.293 33.5129H120.639",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M113.293 42.9713H120.639",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M95.9116 52.4296H103.258",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M95.9116 61.888H103.258",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M95.9116 71.3268H103.258",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M95.9116 24.074H103.258",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M95.9116 14.6157H103.258",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M95.9116 33.5129H103.258",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M95.9116 42.9713H103.258",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M127.947 1.65424H86.2659C84.9408 1.65424 83.8691 3.26952 83.8691 5.27407V37.7167H94.1772C94.6805 37.7708 95.143 38.0184 95.4667 38.4071C95.7904 38.7957 95.9499 39.295 95.9115 39.7991V86.9935H130.344V5.25471C130.344 3.26962 129.272 1.65424 127.947 1.65424Z",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuroPersonaM);
export default __webpack_public_path__ + "static/media/buroPersonaM.86cbec2cbee6c1ec990e12669edec715.svg";
export { ForwardRef as ReactComponent };